import styled from 'styled-components';

export const StyledMap = styled.iframe`
  width: 100%;
  height: 320px;
  border: 0;
  margin-top: 120px;
`;
